// extracted by mini-css-extract-plugin
export var why_col = "style-module--why_col--a4e58";
export var why_colDesc = "style-module--why_col-desc--729e8";
export var why_colIcon = "style-module--why_col-icon--240fe";
export var why_colName = "style-module--why_col-name--e5798";
export var why_row = "style-module--why_row--7576e";